import React from "react";
import {
  HowItWorksBackground,
  HowItWorksCard,
  HowItWorksContainer,
  HowItWorksFooter,
  HowItWorksList,
  HowItWorksSlider,
  HowItWorksSubtitle,
  HowItWorksTitle,
} from "raffle-house-uikit";
import RaffleButton from "../common/RaffleButton";
import { howItWorksItems } from "../../lib/static-data";

const cards = howItWorksItems.map((item, index) => (
  <HowItWorksCard key={index} {...item} />
));

export default function HowItWorks({ onCTAClick }) {
  return (
    <HowItWorksContainer>
      <HowItWorksTitle>How it works</HowItWorksTitle>
      <HowItWorksList>{cards}</HowItWorksList>
      <HowItWorksSlider>{cards}</HowItWorksSlider>
      <HowItWorksSubtitle>
        Your win. Your dream. Your choice.
      </HowItWorksSubtitle>
      <HowItWorksFooter>
        <RaffleButton
          variant="primary"
          size="extra"
          animation
          onClick={onCTAClick}
        >
          Enter now
        </RaffleButton>
      </HowItWorksFooter>
      <HowItWorksBackground
        src={process.env.REACT_APP_AWS_S3_URL + "how-it-works/bg-line.svg"}
      />
    </HowItWorksContainer>
  );
}
